import { motion } from 'framer-motion';
import { Home, User, GraduationCap, Briefcase, Code2, FolderOpen, Award, Mail, Trophy } from 'lucide-react';

interface NavbarProps {
  activeTab: string;
  onTabChange: (tab: string) => void;
}

const Navbar = ({ activeTab, onTabChange }: NavbarProps) => {
  const tabs = [
    { id: 'home', label: 'Home', icon: <Home className="w-4 h-4 md:w-5 md:h-5" /> },
    { id: 'about', label: 'About', icon: <User className="w-4 h-4 md:w-5 md:h-5" /> },
    { id: 'education', label: 'Education', icon: <GraduationCap className="w-4 h-4 md:w-5 md:h-5" /> },
    { id: 'work', label: 'Work', icon: <Briefcase className="w-4 h-4 md:w-5 md:h-5" /> },
    { id: 'skills', label: 'Skills', icon: <Code2 className="w-4 h-4 md:w-5 md:h-5" /> },
    { id: 'projects', label: 'Projects', icon: <FolderOpen className="w-4 h-4 md:w-5 md:h-5" /> },
    { id: 'certifications', label: 'Certifications', icon: <Award className="w-4 h-4 md:w-5 md:h-5" /> },
    { id: 'achievements', label: 'Achievements', icon: <Trophy className="w-4 h-4 md:w-5 md:h-5" /> },
    { id: 'contact', label: 'Contact', icon: <Mail className="w-4 h-4 md:w-5 md:h-5" /> }
  ];

  return (
    <nav className="fixed bottom-0 md:top-0 left-0 h-16 md:h-screen w-full md:w-20 bg-black/60 backdrop-blur-2xl shadow-[0_-8px_32px_rgba(0,0,0,0.5)] md:shadow-[8px_0_32px_rgba(0,0,0,0.5)] z-50 transition-all duration-500 border-t md:border-t-0 border-white/10 md:border-r pb-safe transform-gpu">
      <div className="flex flex-row md:flex-col items-center justify-between md:justify-evenly md:py-8 h-full px-4 md:px-0 w-full overflow-hidden relative">
        {tabs.map((tab) => {
          const isActive = activeTab === tab.id;
          return (
            <motion.button
              key={tab.id}
              onClick={() => onTabChange(tab.id)}
              className={`relative flex-1 md:flex-none p-2 md:p-4 transition-colors duration-300 flex justify-center items-center z-10 ${
                isActive ? 'text-blue-400' : 'text-neutral-500 hover:text-blue-300'
              }`}
              whileHover={{ scale: 1.15 }}
              whileTap={{ scale: 0.9 }}
              title={tab.label}
            >
              {/* Sliding Background Pill */}
              {isActive && (
                <motion.div
                  layoutId="nav-active-glow"
                  className="absolute inset-1 md:inset-2 bg-blue-500/10 border border-blue-500/40 rounded-xl shadow-[0_0_15px_rgba(59,130,246,0.2)]"
                  transition={{
                    type: "tween",
                    ease: "easeOut",
                    duration: 0.35,
                  }}
                />
              )}
              
              <div className="relative z-10 flex items-center justify-center transform-gpu">
                {tab.icon}
              </div>
            </motion.button>
          );
        })}
      </div>
    </nav>
  );
};

export default Navbar; 